import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TokenService } from '../auth/token.service';

@Injectable({
  providedIn: 'root'
})
export class AiChatService {
  api: string = environment.api + '/ai-chat';

  constructor(private httpClient: HttpClient, private tokenService: TokenService) { }

  getSessions(storeId: number, userId: number): Observable<any[]> {
    const headers = this.tokenService.createTokenHeader();
    return this.httpClient.get<any[]>(`${this.api}/sessions`, { params: { storeId: storeId.toString(), userId: userId.toString() }, headers });
  }

  createSession(storeId: number, userId: number, title: string): Observable<any> {
    const headers = this.tokenService.createTokenHeader();
    return this.httpClient.post<any>(`${this.api}/sessions`, null, { params: { storeId: storeId.toString(), userId: userId.toString(), title }, headers });
  }

  getMessages(sessionId: number): Observable<any[]> {
    const headers = this.tokenService.createTokenHeader();
    return this.httpClient.get<any[]>(`${this.api}/messages/${sessionId}`, { headers });
  }

  sendMessage(sessionId: number, content: string): Observable<any> {
    const headers = this.tokenService.createTokenHeader();
    return this.httpClient.post<any>(`${this.api}/send/${sessionId}`, { content }, { headers });
  }
}
